<template>
  <div id="app">
    <router-view></router-view>
    <!-- 开启底部安全区适配 -->
    <van-number-keyboard safe-area-inset-bottom />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
